import type { RequestOptions } from '@@/plugin-request/request';
import { request as umiRequest } from '@umijs/max';
import { BizAppConfig } from 'config/application.manifest';

type ScopedRequestOptions = RequestOptions;

export const createRequest = (baseURL?: string) => {
  const scopedBaseURL = baseURL ?? BizAppConfig.appApiUrl ?? '';
  return <T = unknown>(url: string, options?: ScopedRequestOptions) =>
    (
      umiRequest as unknown as <R = unknown>(
        requestUrl: string,
        requestOptions?: ScopedRequestOptions,
      ) => Promise<R>
    )<T>(url, {
      baseURL: scopedBaseURL,
      ...(options || {}),
    });
};

export const createAppRequest = () => createRequest(BizAppConfig.appApiUrl);

interface CachedUser {
  organizationUuid?: string;
  lastLoginOrganizationUuid?: string;
}

export const createTenantManagementRequest = () => {
  let url = BizAppConfig.appTenantManagementUrl || '';
  if (typeof window !== 'undefined') {
    const tenantUuid = localStorage.getItem('currentTenantUuid') || '';
    let organizationUuid = '';
    try {
      const userJson = localStorage.getItem('user');
      if (userJson) {
        const user = JSON.parse(userJson) as CachedUser;
        organizationUuid =
          user.organizationUuid || user.lastLoginOrganizationUuid || '';
      }
    } catch {
      // ignore
    }
    url = url
      .replace('{tenantUuid}', tenantUuid)
      .replace('{organizationUuid}', organizationUuid);
  }
  return createRequest(url);
};
